module.exports = __webpack_public_path__ + "static/img/24b.294d09b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/24b.jpg
// module id = ln3J
// module chunks = 0